import { CommonModule } from '@angular/common';
import { Component, OnDestroy, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSidenavContainer, MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { IPaginationResult2 } from 'app/common/interfaces';
import { CustomMatPaginatorIntl } from 'app/mock-api/common/customPaginatorIntl';
import { debounceTime, distinctUntilChanged, Subscription } from 'rxjs';
import { AttentionStockService } from './attention-stock.service';
import { CompanyAttributes, MaterialStockAttributes, WarehouseAttributes } from '@albatrosdeveloper/ave-models-package';
import { FormatOtherDateHourPipe } from 'app/pipes/other-date.pipe';
import { WarehouseService } from 'app/modules/components/configuration/warehouse/warehouse.service';
import { getCode } from 'app/utils/method';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { FilterComponent } from 'app/common/components/filter/filter.component';
import { SearchService } from 'app/layout/common/search-page/search-page.service';
import SalesOfficeAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-office/sales-office.entity';
import { CompanyService } from 'app/modules/components/configuration/company/company.service.service';
import { SalesOfficeService } from 'app/modules/components/configuration/sales-office/sales-office.service';
import { ConfigurationFiltersComponent } from 'app/modules/components/filters/configuration-filters/configuration-filters.component';
import { FilterSectionComponent } from 'app/common/components/filter-section/filter-section.component';
import { DatesFiltersComponent } from 'app/modules/components/filters/dates-filters/dates-filters.component';
import MaterialGroupAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/materials/material-group/material-group.entity';
import { MaterialsManagementFiltersComponent } from 'app/modules/components/filters/materials-management-filters/materials-management-filters.component';
import { IFilters } from 'app/modules/components/filters/interfaces/filterInterface';
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { MatMenuModule, MatMenuTrigger } from "@angular/material/menu";
import { DateHelper } from 'app/utils/date.helper';
import { MaterialService } from 'app/modules/components/material/material/material.service';


@Component({
  selector: 'app-attention-stock',
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavContainer,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatSidenavModule,
    FormsModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatDatepickerModule,
    FormatOtherDateHourPipe,
    MatSelectModule,
    NgxMatSelectSearchModule,
    FilterComponent,
    FilterSectionComponent,
    ConfigurationFiltersComponent,
    DatesFiltersComponent,
    MaterialsManagementFiltersComponent,
    HoverMenuDirective,
    MatMenuModule
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
  ],
  templateUrl: './attention-stock.component.html',
  styleUrl: './attention-stock.component.scss'
})
export class AttentionStockComponent implements OnDestroy {
  getCode = getCode;
  displayedColumns: string[] = [
    //"flag",
    "materialId",
    "warehouseId",
    "unitOfMeasureId",
    "lot",
    "lotExpirationDate",
    "availableStock"
  ];

  dataSource = new MatTableDataSource<MaterialStockAttributes[]>([]);

  totalItems: number = 0;
  searchControl = new FormControl('');
  search: string = '';
  pageSize: number = 50;
  pageIndex: number = 1;
  sortActive: keyof MaterialStockAttributes = "materialId";
  sortDirection: "ASC" | "DESC" = "DESC"

  filter = {
    dateini: new Date(),
    warehouseIds: []
  }

  warehouseList: WarehouseAttributes[] = [];
  warehouseFilterList: WarehouseAttributes[] = [];
  searchWarehouse = ''

  companyList: CompanyAttributes[] = [];
  salesOfficeList: SalesOfficeAttributes[] = [];
  warehouse: WarehouseAttributes[] = [];
  materialGruopList: MaterialGroupAttributes[] = [];
  materialList;
  form: FormGroup;

  //BUSCADOR
  searchSubscription: Subscription;

  loadConfigData = false;
  loadMaterialsData = false;

  //#region Exportar
  fileToUpload: File;
  aux_file = false

  constructor(
    private attentionStockService: AttentionStockService,
    private readonly warehouseService: WarehouseService,
    private readonly searchService: SearchService,
    private snackBar: MatSnackBar,
    private readonly companyService: CompanyService,
    private readonly salesOfficeService: SalesOfficeService,
    private fb: FormBuilder,
  ) {
    const today = new Date(); 
    this.form = this.fb.group({
      companyId: [null],
      pickerDue_start: [null],
      pickerDue_end: [null],
      salesOfficeId: [[]],
      warehouseId: [[]],
      materialId: [],
      materialGroupId: [],
      materialBrandId: []
    });
  }

  onConfigExpanded(): void {
    this.loadConfigData = true;
  }

  onMaterialsExpanded(): void {
    this.loadMaterialsData = true;
  }

  ngOnInit() {
    // this.fetchCompanies();
    // this.fetchAllSalesOffice();
  }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    // this.fetchAllWarehouses();
    this.onFilter(true);

    this.searchControl.valueChanges
      .pipe(
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe((filterValue: string) => {
        this.pageIndex = 1;
        this.search = filterValue;
        this.onFilter();
      });
  }

  onFilter(init: boolean = false) {
    this.getListReport(init)
  }

  onClearFilter() {
    this.form.reset();

    this.onFilter(true);
  }

  private fetchCompanies(): void {
    this.companyService.findToComboBox().subscribe((res) => {
      this.companyList = res.data;
    });
  }

  private fetchAllSalesOffice(): void {
    this.salesOfficeService
      .findToComboBox()
      .subscribe({
        next: (res) => {
          this.salesOfficeList = res.data;
        },
        error: (err) => {
          this.snackBar.open(err.error.message || "Error al obtener oficinas de venta.","Cerrar",{ duration: 5000});
        },
      });
  }


  applyFilter(filterValue: string) {
    this.pageIndex = 1
    this.search = filterValue
    this.getListReport()
  }

  public onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.applyFilter(term)
      });
  }
// this.form = this.fb.group({
    //       companyId: [null, Validators.required],
    //       pickerDue_start: [today],
    //       pickerDue_end: [today],
    //       salesOfficeId: [[]],
    //       warehouseId: [[]],
    //       materialId: [],
    //       materialGroupId: [],
    //       materialBrandId: []
    //     });
  getListReport(init: boolean = false) {
    let options = { currentPage: this.pageIndex, limitPerPage: this.pageSize, search: this.search, sort: this.sortActive, sortDirection: this.sortDirection }

    let dataFilter = {
          pickerDue_start: null,
          pickerDue_end: null,
          warehouseWithMongoId: null,
          materialId: null
    }
    
    if(!init){
      dataFilter = {
        pickerDue_start: DateHelper.getStartOfDay(this.form.get("pickerDue_start")?.value),
        pickerDue_end: DateHelper.getEndOfDay(this.form.get("pickerDue_end")?.value) ?? DateHelper.getEndOfDay(this.form.get("pickerDue_start")?.value) ?? null,
        warehouseWithMongoId: this.form.get("warehouseId")?.value,
        materialId: this.form.get("materialId")?.value
      };
    }

    this.attentionStockService.getAllPaginate(options, 
      dataFilter.warehouseWithMongoId,
      dataFilter.materialId,
      dataFilter.pickerDue_start,
      dataFilter.pickerDue_end
    ).subscribe({
      next: (res: IPaginationResult2<any>) => {
        this.dataSource.data = res?.data ?? [];
        this.totalItems = res?.pageInfo.totalCount ?? 0;

      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener información del reporte.", "Cerrar", { duration: 5000 });
      },
    })
  }

  changeSort(e) {
    this.sortActive = e.active
    this.sortDirection = e.direction?.toUpperCase() || 'ASC'
    this.getListReport()
  }

  changePage(e) {
    this.pageIndex = (e.pageIndex + 1)
    this.pageSize = e.pageSize
    this.getListReport()
  }

  openExportSidenav() {

  }

  downloadStockTemplate() {
    const url = this.attentionStockService.getFileTemplateStock();
    if (!url) {
      this.snackBar.open("Plantilla no disponible.", "Cerrar", {
        duration: 3000,
      });
      return;
    }
    window.open(url);
  }

  async handleFileInput(event) {
    this.aux_file = true
    this.fileToUpload = event.target.files[0];
    if(this.fileToUpload){
      if(this.fileToUpload.type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
        this.snackBar.open("Ingrese solo de tipo .xlsx", "Cerrar", {duration: 3000})
      }
    }else{
      this.aux_file = false
    } 
  }

  onMessageConfirm(){
    if(this.fileToUpload){

      let send = {
        file: this.fileToUpload
      }

      //formdata
      let formdata = new FormData()
      for(let key in send){  
        formdata.append(key,send[key])
      }

      this.attentionStockService.importFile(formdata).subscribe({
        next: (res: any) => {
          this.snackBar.open(res.message, "Cerrar", {duration: 3000})
          this.aux_file = false
          this.getListReport()
        },
        error: (err) => {
          this.aux_file = false
          this.snackBar.open(err.error.message || 'Error al subir el registro', 'Cerrar', { duration: 3000 });
        },
      })
    }
  }
  
  //filter
  private fetchAllWarehouses(): void {
    this.warehouseService.findToComboBox().subscribe({
      next: (res) => {
        this.warehouseList = res.data;
        this.warehouseFilterList = this.warehouseList.slice();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener almacenes.","Cerrar",{ duration: 5000});
      },
    });
  }

  changueOptionsWarehouse(event) {
    if (!this.warehouseList) {
      return;
    }
    let search = event;
    if (!search) {
      this.warehouseFilterList = this.warehouseList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.warehouseFilterList = this.warehouseList.filter(item => item.externalKeys?.code.toLowerCase().indexOf(search) > -1 || item.name.toLowerCase().indexOf(search) > -1)
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
